module.exports = __webpack_public_path__ + "img/yin.3b681642.png";